var _rect, _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoadRunner(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    rx: 10,
    fill: "url(#paint0_linear_1885_13054)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0004 17.4998H90V89.9996H10.0004V17.4998ZM12.5007 20.2889V87.2088H87.4989V20.2889H12.5007ZM89.9996 10V15.0005H10V10H89.9996ZM16.2506 11.2505C15.56 11.2505 15.0009 11.8097 15.0009 12.5002C15.0009 13.1907 15.56 13.7499 16.2506 13.7499C16.9411 13.7499 17.5003 13.1907 17.5003 12.5002C17.5003 11.8097 16.9411 11.2505 16.2506 11.2505ZM23.7504 11.2505C23.0598 11.2505 22.5007 11.8097 22.5007 12.5002C22.5007 13.1907 23.0599 13.7499 23.7504 13.7499C24.4409 13.7499 25.0001 13.1907 25.0001 12.5002C25.0001 11.8097 24.4409 11.2505 23.7504 11.2505ZM30.0005 11.2505C29.31 11.2505 28.75 11.8097 28.75 12.5002C28.75 13.1907 29.31 13.7499 30.0005 13.7499C30.6903 13.7499 31.2502 13.1907 31.2502 12.5002C31.2502 11.8097 30.6902 11.2505 30.0005 11.2505Z",
    fill: "#222222"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62.3751 67.1367C62.1407 67.3694 61.8227 67.4999 61.4912 67.4999H38.5117C38.1803 67.4999 37.8622 67.3694 37.6278 67.1367C30.7933 60.3566 30.7933 51.8649 37.6278 45.085C44.4614 38.305 55.5421 38.305 62.3751 45.085C69.2096 51.8651 69.2096 60.3568 62.3751 67.1367ZM60.6073 46.852C54.7497 41.0497 45.2528 41.0497 39.3952 46.852C33.6574 52.5347 33.5393 59.1749 39.0411 64.9997H60.9621C66.4639 59.1746 66.3459 52.5345 60.608 46.852H60.6073ZM50.0012 50L52.5015 64.9997H47.501L50.0012 50ZM38.7616 57.4898V59.99H33.762V57.4898H38.7616ZM66.2602 57.4898V59.99H61.2606V57.4898H66.2602ZM62.2894 46.2434L64.0564 48.0104L60.5216 51.5461L58.7538 49.7782L62.2894 46.2434ZM37.42 46.292L41.5155 49.1597L40.0817 51.2079L35.9861 48.3402L37.42 46.292ZM51.2503 41.2506V46.2502H48.7509V41.2506H51.2503Z",
    fill: "#222222"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1885_13054",
    x1: 7.45058e-7,
    y1: 50,
    x2: 100,
    y2: 50,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C9DEF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#E4BBC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8A4C9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadRunner);
export default __webpack_public_path__ + "static/media/load_runner.995617c8fc208ab5428feb96ea0a8e28.svg";
export { ForwardRef as ReactComponent };